<template>
  <div class="data-rating-wrap">
    <!-- 1. 总得分 -->
    <div class="collapse-item">
      <div class="collapse-header" :class="{ active: collapseMap.overall }" @click="toggleCollapse('overall')">
        <div class="category-arrow">
          <img :src="collapseMap.overall
            ? require('@/assets/images/chatpreview/arrow-down.svg')
            : require('@/assets/images/chatpreview/arrow-right.svg')
            " alt="arrow" />
        </div>
        <span>总得分</span>
      </div>
      <div class="collapse-body" v-show="collapseMap.overall">
        <div class="overall-content">
          <!-- 左侧评分卡片 -->
          <div class="score-card">
            <div class="score-number">
              {{ previewData?.dimensions?.overall?.summary?.score?.value || 0 }}
            </div>
            <div class="score-label">综合评分</div>
            <div class="grade-box">
              <div class="grade-letter" :class="gradeInfo.class">
                {{ gradeInfo.text }}
              </div>
              <div class="grade-label">等级</div>
            </div>
          </div>

          <!-- 右侧表格 -->
          <div class="table-container">
            <div class="table-header">
              <div v-for="(h, i) in realTableHeaders" :key="i" class="table-header-cell">
                {{ h }}
              </div>
            </div>

            <div class="table-body">
              <div v-for="(row, idx) in realTableData" :key="idx" class="table-body-row">
                <div v-for="(cell, cidx) in row" :key="cidx" class="table-body-cell">
                  <template v-if="realTableHeaders?.[cidx] === '占比'">
                    <div class="progress-bar-wrap">
                      <div class="progress-bar">
                        <div class="progress-fill" :style="{ width: cell }"></div>
                      </div>
                      <span class="progress-text">{{ cell }}</span>
                    </div>
                  </template>
                  <template v-else>
                    <span class="cell-content">{{ cell || '--' }}</span>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 2. 活动数据 -->
    <div class="collapse-item">
      <div class="collapse-header" :class="{ active: collapseMap.activity_data }"
        @click="toggleCollapse('activity_data')">
        <div class="category-arrow">
          <img :src="collapseMap.activity_data
            ? require('@/assets/images/chatpreview/arrow-down.svg')
            : require('@/assets/images/chatpreview/arrow-right.svg')
            " alt="arrow" />
        </div>
        <span>活动数据</span>
      </div>
      <div class="collapse-body" v-show="collapseMap.activity_data">
        <div class="table-container" v-if="previewData?.dimensions.activity_data?.table">
          <div class="table-header">
            <div v-for="(h, i) in previewData.dimensions.activity_data.table.headers" :key="i" class="table-header-cell"
              :style="{
                textAlign: h !== '排放源' ? 'center' : 'left'
              }">
              {{ h }}
            </div>
          </div>
          <div class="table-body">
            <div v-for="(row, idx) in activityTableData" :key="idx" class="table-body-row">
              <div v-for="(cell, cidx) in row" :key="cidx" class="table-body-cell" :style="{
                textAlign:
                  previewData?.dimensions?.activity_data?.table?.headers?.[cidx] !== '排放源'
                    ? 'center'
                    : 'left'
              }">
                <template v-if="previewData?.dimensions?.activity_data?.table?.headers?.[cidx] == '数据类别'">
                  <span class="category-tag" :class="getTagClass(cell)">
                    {{ cell || "--" }}
                  </span>
                </template>
                <template v-else>
                  <span class="cell-content">{{ cell || "--" }}</span>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 3. 排放因子 -->
    <div class="collapse-item">
      <div class="collapse-header" :class="{ active: collapseMap.emission_factor }"
        @click="toggleCollapse('emission_factor')">
        <div class="category-arrow">
          <img :src="collapseMap.emission_factor
            ? require('@/assets/images/chatpreview/arrow-down.svg')
            : require('@/assets/images/chatpreview/arrow-right.svg')
            " alt="arrow" />
        </div>
        <span>排放因子</span>
      </div>
      <div class="collapse-body" v-show="collapseMap.emission_factor">
        <div class="table-container" v-if="previewData?.dimensions.emission_factor?.table">
          <div class="table-header">
            <div v-for="(h, i) in previewData.dimensions.emission_factor.table.headers" :key="i"
              class="table-header-cell" :style="{
                textAlign: h !== '排放源' ? 'center' : 'left'
              }">
              {{ h }}
            </div>
          </div>
          <div class="table-body">
            <div v-for="(row, idx) in factorTableData" :key="idx" class="table-body-row">
              <div v-for="(cell, cidx) in row" :key="cidx" class="table-body-cell" :style="{
                textAlign:
                  previewData?.dimensions?.emission_factor?.table?.headers?.[cidx] !== '排放源'
                    ? 'center'
                    : 'left'
              }">
                <template v-if="previewData?.dimensions?.emission_factor?.table?.headers?.[cidx] === '因子类别'">
                  <span class="category-tag" :class="getFactorTagClass(cell)">
                    {{ cell || "--" }}
                  </span>
                </template>
                <template v-else>
                  <span class="cell-content">{{ cell || "--" }}</span>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DataRating",
  props: {
    previewData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      collapseMap: {
        overall: true, // 默认展开总得分
        activity_data: false,
        emission_factor: false
      }
    };
  },
  computed: {
    // 总得分表头
    realTableHeaders() {
      return this.previewData?.dimensions?.overall?.table?.headers || []
    },
    // 总得分表格真实数据
    realTableData() {
      return this.previewData?.dimensions?.overall?.table?.value || []
    },
    // 活动数据表格真实数据
    activityTableData() {
      return this.previewData?.dimensions?.activity_data?.table?.value || []
    },
    // 排放因子表格真实数据
    factorTableData() {
      return this.previewData?.dimensions?.emission_factor?.table?.value || []
    },
    gradeInfo() {
      const num = Number(this.previewData?.dimensions?.overall?.summary?.grade?.value || 6);
      const map = {
        1: { text: "L1", class: "grade-l1" },
        2: { text: "L2", class: "grade-l2" },
        3: { text: "L3", class: "grade-l3" },
        4: { text: "L4", class: "grade-l4" },
        5: { text: "L5", class: "grade-l5" },
        6: { text: "L6", class: "grade-l6" },
      };
      return map[num] || map[6];
    },
    getTagClass() {
      return function (text) {
        switch (text) {
          case "连续测量":
          case "直接测量":
            return "tag-green";
          case "间接测量":
          case "间歇监测":
            return "tag-yellow";
          case "自行推估":
            return "tag-gray";
          default:
            return "tag-gray";
        }
      };
    },
    getFactorTagClass() {
      return function (text) {
        switch (text) {
          case "国家排放因子":
            return "tag-purple";
          case "国际排放因子":
            return "tag-blue";
          case "测量/质量平衡所得因子":
            return "tag-cyan";
          case "相同工艺或设备的经验因子":
            return "tag-green";
          case "设备制造商提供的因子":
            return "tag-orange";
          case "区域排放因子":
            return "tag-pink";
          default:
            return "tag-gray";
        }
      };
    }
  },
  methods: {
    toggleCollapse(key) {
      if (this.collapseMap[key]) {
        this.collapseMap[key] = false;
      } else {
        Object.keys(this.collapseMap).forEach(k => {
          this.collapseMap[k] = false;
        });
        this.collapseMap[key] = true;
      }
    }
  }
};
</script>

<style scoped>
.data-rating-wrap {
  padding: 12px;
}

.collapse-item {
  margin-bottom: 8px;
  background: #fff;
  overflow: hidden;
}

.collapse-header {
  padding: 10px 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  color: #999;
  transition: color 0.2s;
}

.collapse-header.active {
  color: #1f2937;
  border-radius: 8px;
  background: #DBE8F5;
}

.category-arrow img {
  width: 12px;
  height: 12px;
  display: block;
}

.collapse-body {
  padding: 12px;
}

.overall-content {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

.score-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 80px;
}

.score-number {
  font-size: 36px;
  font-weight: bold;
  color: #1f2937;
}

.score-label {
  font-size: 14px;
  color: #666;
  margin-top: 4px;
}

.grade-box {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.grade-letter {
  width: 48px;
  height: 48px;
  background: #2e7d32;
  border-radius: 8px;
  color: #fff;
  font-size: 24px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
}

.grade-l1 { background: #2e7d32; }
.grade-l2 { background: #66bb6a; }
.grade-l3 { background: #a5d6a7; color: #333; }
.grade-l4 { background: #f0c060; color: #333; }
.grade-l5 { background: #f28b50; }
.grade-l6 { background: #b74747; }

.grade-label {
  font-size: 14px;
  color: #666;
  margin-top: 4px;
}

.table-container {
  flex: 1;
}

.table-header {
  display: flex;
  padding: 8px 0;
  color: #999;
  font-size: 14px;
}

.table-header-cell {
  flex: 1;
  text-align: center;
}

.table-body {
  border-top: 1px solid #eee;
}

.table-body-row {
  display: flex;
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
  align-items: center;
}

.table-body-cell {
  flex: 1;
  text-align: center;
  font-size: 14px;
  overflow: hidden;
}

.category-tag {
  margin: 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 28px;
  padding: 0 12px;
  border-radius: 14px;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  white-space: nowrap;
}

.tag-green { background-color: #6BA86B; }
.tag-yellow { background-color: #E0B054; }
.tag-gray { background-color: #AAB3BB; }
.tag-purple { background-color: #9c27b0; }
.tag-blue { background-color: #2196f3; }
.tag-cyan { background-color: #26a69a; }
.tag-orange { background-color: #f28b50; }
.tag-pink { background-color: #D76C89; }

.cell-content {
  display: inline-block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.progress-bar-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
}

.progress-bar {
  flex: 1;
  height: 8px;
  background: #e0e0e0;
  border-radius: 4px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: #2196f3;
  border-radius: 4px;
}

.progress-text {
  font-size: 12px;
  color: #666;
  min-width: 32px;
  text-align: right;
}
</style>